import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, Store } from 'lucide-react';
import { DictionaryType } from './types';
import { Dashboard } from './components/zone1/Dashboard';
import { DetailView } from './components/zone1/DetailView';
import { CollectionList } from './components/zone2/CollectionList';
import { CollectionDetail } from './components/zone2/CollectionDetail';
import { CollectionCreate } from './components/zone2/CollectionCreate';
import { SecretKeyManager } from './components/zone2/SecretKeyManager';
import { ToastProvider } from './context/ToastContext';

// Zone 1 Component Wrapper
const Zone1View: React.FC = () => {
  const [activeDictionary, setActiveDictionary] = useState<DictionaryType | null>(null);

  return activeDictionary ? (
    <DetailView
      dictType={activeDictionary}
      onBack={() => setActiveDictionary(null)}
    />
  ) : (
    <Dashboard onEdit={(type) => setActiveDictionary(type)} />
  );
};

// Global Navigation Header
const NavigationHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isZone2 = location.pathname.startsWith('/collections');

  return (
    <header
      className="app-nav-header"
      style={{
        backgroundColor: '#ffffff',
        borderBottom: '1px solid var(--border-light)',
        padding: '0.75rem 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <h1
        className="app-title"
        onClick={() => navigate('/')}
        style={{
          fontSize: '1.25rem',
          fontWeight: 700,
          color: 'var(--text-main)',
          margin: 0,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        QT Collection
      </h1>
      <div style={{ display: 'flex', gap: '0.375rem', flexShrink: 1, minWidth: 0 }}>
        <button
          onClick={() => navigate('/')}
          className="nav-tab-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            padding: '0.5rem 0.75rem',
            borderRadius: '0.375rem',
            backgroundColor: !isZone2 ? 'var(--accent-highlight)' : 'transparent',
            color: 'var(--text-on-light)',
            fontWeight: !isZone2 ? 600 : 400,
            border: 'none',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          <BookOpen size={16} style={{ flexShrink: 0 }} />
          <span className="nav-btn-text-full">Từ Điển Cá Nhân</span>
          <span className="nav-btn-text-short">Từ Điển</span>
        </button>
        <button
          onClick={() => navigate('/collections')}
          className="nav-tab-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            padding: '0.5rem 0.75rem',
            borderRadius: '0.375rem',
            backgroundColor: isZone2 ? 'var(--accent-highlight)' : 'transparent',
            color: 'var(--text-on-light)',
            fontWeight: isZone2 ? 600 : 400,
            border: 'none',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          <Store size={16} style={{ flexShrink: 0 }} />
          <span className="nav-btn-text-full">Bộ Sưu Tập Được Chia Sẻ</span>
          <span className="nav-btn-text-short">Bộ Sưu Tập</span>
        </button>
      </div>
    </header>
  );
};

export const App: React.FC = () => {
  return (
    <ToastProvider>
      <BrowserRouter>
        <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-primary)' }}>
          <NavigationHeader />
          <main style={{ maxWidth: '960px', margin: '0 auto', padding: '1.25rem 1rem' }}>
            <Routes>
              {/* Zone 1 - Route riêng cho Xưởng cá nhân */}
              <Route path="/" element={<Zone1View />} />

              {/* Zone 2 - Routes riêng hoàn toàn cho Bộ Sưu Tập */}
              <Route path="/collections" element={<CollectionList />} />
              <Route path="/collections/:id" element={<CollectionDetail />} />
              <Route path="/c/:id" element={<CollectionDetail />} />
              <Route path="/collections/create" element={<CollectionCreate />} />
              <Route path="/collections/keys" element={<SecretKeyManager />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ToastProvider>
  );
};

export default App;
